import { Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { useBillingDemo } from './useBillingDemo';
import BillingDemoPanel from './BillingDemoPanel';
export default function SubscriptionGatedPage() {
  const { teamSlug = '' } = useParams<{ teamSlug: string }>();
  const resource = useBillingDemo(teamSlug);
  return (
    <Stack spacing={3}>
      <BillingDemoPanel
        title="Subscription Access"
        data={resource.data}
        loading={resource.loading}
        error={resource.error}
        onRetry={resource.retry}
      />
      {resource.data?.hasAccess && (
        <Typography>This page demonstrates the server's current subscription access decision for your team.</Typography>
      )}
      <Button component={RouterLink} to={`/a/${teamSlug}/subscription/demo`}>
        Back to Subscription Demo
      </Button>
    </Stack>
  );
}
